const font = {
  primary: 'Inter, sans-serif',
  secondary: 'Unbounded, cursive',
};
export default font;
